import { Box, Stack, IconButton, Typography } from "@mui/material";
import {
  Star,
  StarBorder,
  ChatBubbleOutline,
  ShoppingCartOutlined,
} from "@mui/icons-material";
import { useState, useContext, useEffect } from "react";
import { toggleFavorite } from "@/services/api";
import ActiveContentDrawer from "@/components/ActiveContentDrawer";
import { SubscribedContext } from "@/providers/Subscribed";

export default function NoteActions({ content }) {
  return (
    <Stack direction="row" spacing={2} sx={{ mt: 1 }} alignItems="center">
      {content.type == "audio" ? (
        <Typography variant="body1">{content.meta.title}</Typography>
      ) : (
        <FavoriteButton content={content} />
      )}
      <CommentButton content={content} />
      {content.type == "merch" && <CartButton content={content} />}
    </Stack>
  );
}

const FavoriteButton = ({ content }) => {
  const [favorite, setFavorite] = useState(content.user_favorite);
  const [favoriteCount, setFavoriteCount] = useState(content.favorite_count);
  const { isSubscribed, handleModalOpen } = useContext(SubscribedContext);

  // Sync state with content prop when it changes (e.g., after parent refetches)
  useEffect(() => {
    setFavorite(content.user_favorite);
    setFavoriteCount(content.favorite_count);
  }, [content.user_favorite, content.favorite_count]);

  const handleFavorite = async () => {
    if (!isSubscribed) {
      handleModalOpen();
      return;
    }
    const newFavoriteState = !favorite;
    const newFavoriteCount = newFavoriteState
      ? favoriteCount + 1
      : favoriteCount - 1;

    // Optimistic update
    setFavorite(newFavoriteState);
    setFavoriteCount(newFavoriteCount);

    const response = await toggleFavorite(content);

    // Update the content prop so it persists across remounts
    // do it after the API piece tho per logic in api.js
    content.user_favorite = newFavoriteState;
    content.favorite_count = newFavoriteCount;
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <IconButton onClick={handleFavorite} sx={{ ml: -1 }}>
        {favorite ? <Star color="secondary" /> : <StarBorder />}
      </IconButton>
      <Typography variant="caption">
        {favoriteCount > 0 && favoriteCount}
      </Typography>
    </Box>
  );
};

const CartButton = ({ content }) => {
  const [open, setOpen] = useState(false);
  const { isSubscribed, handleModalOpen } = useContext(SubscribedContext);
  const handleOpen = () => {
    if (!isSubscribed) {
      handleModalOpen();
      return;
    }
    setOpen(true);
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <IconButton onClick={handleOpen}>
        <ShoppingCartOutlined />
      </IconButton>

      <ActiveContentDrawer content={content} open={open} setOpen={setOpen} />
    </Box>
  );
};
const CommentButton = ({ content }) => {
  const [open, setOpen] = useState(false);
  const { isSubscribed, handleModalOpen } = useContext(SubscribedContext);
  const handleOpen = () => {
    if (!isSubscribed) {
      handleModalOpen();
      return;
    }
    setOpen(true);
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <IconButton onClick={handleOpen}>
        <ChatBubbleOutline />
      </IconButton>
      <Typography variant="caption">
        {content.comment_count > 0 && content.comment_count}
      </Typography>
      <ActiveContentDrawer content={content} open={open} setOpen={setOpen} />
    </Box>
  );
};
